<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-container>
    <v-card>
      <v-img
        v-if="album.cover"
        style="position: relative"
        :src="album.cover.url"
        aspect-ratio="2.75"
        contain
        :lazy-src="require('@/assets/images/img_404.png')"
        alt=""
      ></v-img>
      <v-card-title primary-title>
        <v-text-field v-model="album.title"></v-text-field>
      </v-card-title>
      <v-card-text>
        <v-textarea v-model="album.description" label="Описание"></v-textarea>
        <v-text-field
          label="Родительский альбом"
          required
          v-model="parentTitle"
          type="text"
          @click="modal = true"
        >
          <template v-slot:append v-if="parentTitle">
            <v-btn icon @click="removeParent">
              <v-icon color="error">mdi-close</v-icon>
            </v-btn>
          </template>
        </v-text-field>
      </v-card-text>
      <v-card-text> </v-card-text>
      <v-card-actions>
        <v-col cols="12">
          <v-switch color="green" v-model="album.published" label="Опубликован"></v-switch>
          <v-switch color="green" v-model="album.on_top" label="Закрепить"></v-switch>
        </v-col>
      </v-card-actions>
      <v-card-actions>
        <v-btn color="success" @click="updateAlbum">Сохранить</v-btn>
        <v-spacer></v-spacer>
        <v-btn color="error" @click="remove">Удалить</v-btn>
      </v-card-actions>
    </v-card>

    <v-dialog v-model="modal" max-width="500px">
      <v-card>
        <v-card-text class="text-lg-center">
          <v-text-field v-model="albumSearch" label="Поиск"></v-text-field>
          <v-list>
            <transition-group
              name="slide-x-transition"
              tag="div"
              role="list"
              class="v-list v-list-two-line"
            >
              <v-list-item v-for="m in albumList" :key="m.id" avatar @click="selectAlbum(m)">
                <v-list-item-title>
                  <v-list-item-avatar v-if="m.cover.sizes">
                    <img :src="m.cover.sizes['50']" />
                  </v-list-item-avatar>
                  <v-list-item-content style="cursor: pointer">
                    <v-list-item-title v-html="m.title"></v-list-item-title>
                    <v-list-item-subtitle v-html="m.description"></v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item-title>
              </v-list-item>
            </transition-group>
          </v-list>
        </v-card-text>
        <v-card-text> </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="text-lg-center">
          <v-col cols="12" align-self-center>
            <v-btn color="secondary" flat @click="modal = false">Закрыть</v-btn>
          </v-col>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-card style="position: relative">
      <v-card-actions>
        <v-dialog v-model="addImagesDialog" max-width="600px">
          <template v-slot:activator="{ on }">
            <v-btn dark bottom right fab color="secondary" style="top: 30px" v-on="on">
              <v-icon dark>add</v-icon>
            </v-btn>
          </template>
          <v-card>
            <v-card-title>
              <span class="headline">Добавить изображения</span>
            </v-card-title>
            <v-card-text>
              <v-container grid-list-md>
                <v-row wrap>
                  <v-col xs12 class="text-xs-center text-sm-center text-md-center text-lg-center">
                    <v-container grid-list-lg="true" fluid>
                      <v-row row wrap>
                        <v-col v-for="(el, i) in files" :key="i" xs4>
                          <v-card flat tile>
                            <v-img contain :src="el.url"></v-img>
                          </v-card>
                        </v-col>
                      </v-row>
                    </v-container>
                    <v-text-field
                      label="Выберите фотографии"
                      @click="pickFile"
                      prepend-icon="attach_file"
                    ></v-text-field>
                    <input
                      type="file"
                      style="display: none"
                      ref="images"
                      accept="image/*"
                      multiple
                      required
                      @change="onFilePicked"
                    />
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <!--                            <v-btn color="primary" @click="addImagesDialog = false">Закрыть</v-btn>-->
              <v-btn color="primary" @click="saveFiles">Сохранить</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-spacer></v-spacer>
      </v-card-actions>
      <v-container fluid>
        <v-row>
          <v-col v-for="(img, i) in album.images" :key="i" xs4>
            <v-card flat tile>
              <v-img contain :src="img.url" max-width="300px">
                <v-menu right>
                  <template v-slot:activator="{ on }">
                    <v-btn color="secondary" icon v-on="on">
                      <v-icon>more_vert</v-icon>
                    </v-btn>
                  </template>

                  <v-list>
                    <v-list-item class="pointer">
                      <v-list-item-title @click="setAsCover(album.id, img.id)"
                        >Сделать обложкой альбома
                      </v-list-item-title>
                    </v-list-item>
                    <v-list-item class="pointer">
                      <v-list-item-title @click="deleteImage(album.id, img.id)"
                        >Удалить из альбома
                      </v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </v-img>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-card>

    <ListView
      v-if="album.child"
      :label="'Вложенные альбомы'"
      :items="album.child"
      :with-sites="false"
      color="primary"
      :edit-item="'photo_albums_edit'"
      :site="album.site_key"
      :avatar-url="'cover.sizes.50'"
      :items-name="'albums'"
      @remove-item="updateData"
    >
      <template v-slot:info="{ item }">
        <v-btn icon v-if="item.on_top" disabled>
          <v-icon color="green">mdi-pin</v-icon>
        </v-btn>
        <v-btn icon v-if="item.published" disabled>
          <v-icon color="green">mdi-check</v-icon>
        </v-btn>
      </template>
    </ListView>
  </v-container>
</template>

<script>
import ListView from '@/components/ListView'

export default {
  name: 'AlbumEdit',
  components: { ListView },
  data() {
    return {
      modal: false,
      parentTitle: '',
      parent: null,
      albumSearch: '',
      albumList: [],
      album: { cover: '', parent_id: null },
      addImagesDialog: false,
      changeCoverDialog: false,
      files: [],
      titleEdit: false,
      tempTitle: '',
    }
  },
  computed: {
    isEdit() {
      return !!this.$route.params.id
    },
    inputTitle: {
      get() {
        return this.album.title
      },
      set(v) {
        this.tempTitle = v
      },
    },
  },
  watch: {
    albumSearch() {
      this.searchAlbum()
    },
    '$route.params.id': function () {
      this.updateData()
    },
  },
  mounted() {
    this.updateData()
  },
  methods: {
    updateData() {
      this.axios({ url: `/v1/albums/${this.$route.params.id}`, method: 'get' })
        .then((resp) => {
          this.album = resp.data
          if (this.album.parent) {
            this.parentTitle = this.album.parent.title
          }
        })
        .catch((err) => {
          this.showSnackbar(err.response.data, 'error')
        })
    },
    remove() {
      this.axios({ url: `/v1/albums/${this.album.id}`, method: 'delete' })
        .then(() => {
          this.$router.push({ name: 'photo_albums_list', query: { site_key: this.album.site_key } })
        })
        .catch((err) => {
          this.showSnackbar(err.response ? err.response.data : err, 'error')
          this.$log.error(err.response)
        })
    },
    updateAlbum() {
      this.axios({
        url: `/v1/albums/${this.album.id}`,
        method: 'patch',
        data: this.album,
      })
        .then((res) => {
          this.album = res.data
        })
        .catch((err) => {
          this.showSnackbar(err.response.data, 'error')
        })
    },
    saveTitle() {
      if (this.tempTitle === this.album.title || this.tempTitle === '') {
        this.titleEdit = false
        return
      }
      this.axios({
        url: `/v1/albums/${this.album.id}`,
        method: 'patch',
        data: { title: this.tempTitle },
      }).then((resp) => {
        this.album.title = resp.data.title
        this.titleEdit = false
      })
    },
    saveFiles() {
      this.addImagesDialog = false
      for (let i = 0; i < this.files.length; i++) {
        const el = this.files[i]
        let data = new FormData()
        data.append('file', el.file, el.name)
        data.append('album_id', this.album.id)
        this.axios({
          url: '/v1/images',
          method: 'post',
          data: data,
          config: { headers: { 'content-type': 'multipart/form-data' } },
        }).then((res) => {
          if (!this.album.hasOwnProperty('images') || this.album.images === null) {
            this.album.images = []
          }
          this.album.images.push(res.data)
        })
      }
      this.files = []
    },
    setAsCover(albumId, imgId) {
      this.axios({
        url: `/v1/albums/${albumId}/cover`,
        method: 'post',
        data: { cover_id: imgId },
      })
        .then((res) => {
          this.showSnackbar('Сохранено', 'green')
          this.updateData()
        })
        .catch((err) => {
          this.showSnackbar(err.response.data, 'error')
        })
    },
    deleteImage(albumId, imgId) {
      this.axios({
        url: `/v1/albums/${albumId}/images/${imgId}`,
        method: 'delete',
      })
        .then(() => {
          this.showSnackbar('Удалено', 'green')
          this.updateData()
        })
        .catch((err) => {
          this.showSnackbar(err.response.data, 'error')
        })
    },
    pickFile() {
      this.$refs.images.click()
    },

    onFilePicked(e) {
      const files = e.target.files
      if (files.length > 0) {
        for (let i = 0; i < files.length; i++) {
          const file = files[i]
          const name = file.name
          if (name.lastIndexOf('.') <= 0) {
            continue
          }
          const fr = new FileReader()
          fr.readAsDataURL(file)
          fr.addEventListener('load', () => {
            const url = fr.result
            this.files.push({ name: name, file: file, url: url })
          })
        }
      }
    },
    selectAlbum(e) {
      this.parent = e
      this.parentTitle = e.title
      this.album.parent_id = e.id
      this.modal = false
    },
    searchAlbum() {
      if (!this.albumSearch) {
        this.albumList = []
        return
      }

      this.axios({
        url: '/v1/albums',
        method: 'get',
        params: { title_contains: this.albumSearch, site_key: this.site_key },
      })
        .then((resp) => {
          const data = resp.data
          this.albumList = data ? data : []
        })
        .catch((err) => {
          this.$log.error(err)
          this.showSnackbar(err.response ? err.response.data : err, 'error')
        })
    },
    removeParent() {
      this.parent = {}
      this.parentTitle = ''
      this.album.parent_id = 0
    },
  },
}
</script>
